export const ISSUE_IMAGE_TYPES = {
  RESOLVING: "RESOLVING",
  ORIGINATING: "ORIGINATING",
  ASSESS: "ASSESS",
  REVIEW: "REVIEW",
};

export const ISSUE_IMAGE_TYPE_TO_LABEL = {
  [ISSUE_IMAGE_TYPES.RESOLVING]: "Repair",
  [ISSUE_IMAGE_TYPES.ORIGINATING]: "Diagnosis",
  [ISSUE_IMAGE_TYPES.ASSESS]: "Complaint",
  [ISSUE_IMAGE_TYPES.REVIEW]: "Review",
};

export const FILE_TYPES = {
  PDF: "PDF",
  JPEG: "JPEG",
  JPG: "JPG",
  PNG: "PNG",
  GIF: "GIF",
  DOC: "DOC",
  DOCX: "DOCX",
  MP4: "MP4",
  XLSX: "XLSX",
  XLS: "XLS",
  CSV: "CSV",
  WEBP: "WEBP",
};

export const FILE_MIME_TYPES = {
  PDF: "application/pdf",
  JPG: "image/jpg",
  JPEG: "image/jpeg",
  PNG: "image/png",
  WEBP: "image/webp",
  GIF: "image/gif",
  DOCX: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  DOC: "application/msword",
  MP4: "video/mp4",
  XLS: "application/vnd.ms-excel",
  XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  CSV: "text/csv",
};

export const WORD_MIME_TYPES = [FILE_MIME_TYPES.DOC, FILE_MIME_TYPES.DOCX];

export const FILE_MIME_TYPE_EXTENSIONS = {
  [FILE_MIME_TYPES.PDF]: "pdf",
  [FILE_MIME_TYPES.JPEG]: "jpg",
  [FILE_MIME_TYPES.PNG]: "png",
  [FILE_MIME_TYPES.WEBP]: "webp",
  [FILE_MIME_TYPES.GIF]: "gif",
  [FILE_MIME_TYPES.DOCX]: "docx",
  [FILE_MIME_TYPES.DOC]: "doc",
  [FILE_MIME_TYPES.MP4]: "mp4",
  [FILE_MIME_TYPES.XLSX]: "xlsx",
  [FILE_MIME_TYPES.CSV]: "csv",
};

export const VALID_FILE_OPTIONS = [
  { label: FILE_TYPES.PDF, value: FILE_MIME_TYPES.PDF },
  { label: FILE_TYPES.JPEG, value: FILE_MIME_TYPES.JPEG },
  { label: FILE_TYPES.PNG, value: FILE_MIME_TYPES.PNG },
  { label: FILE_TYPES.WEBP, value: FILE_MIME_TYPES.WEBP },
  { label: FILE_TYPES.GIF, value: FILE_MIME_TYPES.GIF },
  { label: FILE_TYPES.MP4, value: FILE_MIME_TYPES.MP4 },
  { label: FILE_TYPES.XLSX, value: FILE_MIME_TYPES.XLSX },
  { label: FILE_TYPES.CSV, value: FILE_MIME_TYPES.CSV },
  { label: FILE_TYPES.DOCX, value: FILE_MIME_TYPES.DOCX },
  { label: FILE_TYPES.DOC, value: FILE_MIME_TYPES.DOC },
  { label: FILE_TYPES.JPG, value: FILE_MIME_TYPES.JPG },
  { label: FILE_TYPES.XLS, value: FILE_MIME_TYPES.XLS },
];

export const VALID_FILE_MIME_TYPES = [
  FILE_MIME_TYPES.PNG,
  FILE_MIME_TYPES.JPEG,
  FILE_MIME_TYPES.WEBP,
  FILE_MIME_TYPES.GIF,
  FILE_MIME_TYPES.PDF,
  FILE_MIME_TYPES.DOC,
  FILE_MIME_TYPES.DOCX,
  FILE_MIME_TYPES.XLSX,
  FILE_MIME_TYPES.CSV,
];

export const VALID_DOCUMENT_VIEWER_FILE_MIME_TYPES = [
  FILE_MIME_TYPES.PNG,
  FILE_MIME_TYPES.JPEG,
  FILE_MIME_TYPES.WEBP,
  FILE_MIME_TYPES.GIF,
  FILE_MIME_TYPES.PDF,
  FILE_MIME_TYPES.DOC,
  FILE_MIME_TYPES.DOCX,
];

export const VALID_BID_DOCUMENT_FILE_MIME_TYPES = [
  FILE_MIME_TYPES.PDF,
  FILE_MIME_TYPES.XLSX,
  FILE_MIME_TYPES.XLS,
  FILE_MIME_TYPES.CSV,
  FILE_MIME_TYPES.DOCX,
  FILE_MIME_TYPES.DOC,
  FILE_MIME_TYPES.JPEG,
  FILE_MIME_TYPES.JPG,
  FILE_MIME_TYPES.PNG,
  FILE_MIME_TYPES.WEBP,
];

export const VIDEO_FILE_MIME_TYPES = [
  "video/mp4",
  "video/mpeg",
  "video/quicktime",
  "video/webm",
  "video/ogg",
];

export const VALID_IMAGE_FILE_MIME_TYPES = [
  FILE_MIME_TYPES.PNG,
  FILE_MIME_TYPES.JPEG,
  FILE_MIME_TYPES.WEBP,
  FILE_MIME_TYPES.GIF,
];

export const DOCUMENT_TYPES = {
  UNKNOWN: "Unknown",
  IMAGE: "Image",
  SPECSHEET: "Spec Sheet",
  CAD: "CAD",
  LOCATES: "Locates",
  OPTIONS: "Options",
  QUOTE: "Quote",
};

export const TECHNICIAN_STATUSES_TYPES = {
  AVAILABILITY: "AvailabilityStatus",
  ACTIVITY: "ActivityStatus",
};

export const INPUT_TYPES = {
  SELECT: "select",
  AUTOCOMPLETE: "autocomplete",
  CHECKBOX: "checkbox",
  SWITCH: "switch",
  RADIO_GROUP: "radioGroup",
  MULTI_SELECT: "multiSelect",
  TEXTBOX: "textbox",
  EMPTY_FIELD: "emptyField",
  CUSTOM: "custom",
  NUMBER: "number",
  CURRENCY: "currency",
  TEXTAREA: "textarea",
  NUMERIC: "numeric",
  TIME: "time",
  TIME_PICKER: "timePicker",
};

export const IMAGE_FILE_TYPES = [
  FILE_TYPES.JPEG,
  FILE_TYPES.PNG,
  FILE_TYPES.JPG,
  FILE_TYPES.GIF,
  FILE_TYPES.WEBP,
];
